/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CircleData } from '../model/circleData';
import { CreateCirclePayload } from '../model/createCirclePayload';
import { UpdateCirclePayload } from '../model/updateCirclePayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CircleOfEndusersService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create circle
     * 
     * @param payload Circle creation information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCircle(payload?: CreateCirclePayload, observe?: 'body', reportProgress?: boolean): Observable<CircleData>;
    public createCircle(payload?: CreateCirclePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CircleData>>;
    public createCircle(payload?: CreateCirclePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CircleData>>;
    public createCircle(payload?: CreateCirclePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CircleData>(`${this.basePath}/api/circles`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete circle
     * 
     * @param circleId Circle
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCircle(circleId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCircle(circleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCircle(circleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCircle(circleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling deleteCircle.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get circle
     * 
     * @param circleId Circle
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCircle(circleId: string, observe?: 'body', reportProgress?: boolean): Observable<CircleData>;
    public getCircle(circleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CircleData>>;
    public getCircle(circleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CircleData>>;
    public getCircle(circleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling getCircle.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CircleData>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update circle
     * 
     * @param circleId Circle
     * @param payload Circle data to update (null values ignored)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCircle(circleId: string, payload?: UpdateCirclePayload, observe?: 'body', reportProgress?: boolean): Observable<CircleData>;
    public updateCircle(circleId: string, payload?: UpdateCirclePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CircleData>>;
    public updateCircle(circleId: string, payload?: UpdateCirclePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CircleData>>;
    public updateCircle(circleId: string, payload?: UpdateCirclePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (circleId === null || circleId === undefined) {
            throw new Error('Required parameter circleId was null or undefined when calling updateCircle.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CircleData>(`${this.basePath}/api/circles/${encodeURIComponent(String(circleId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
